module.exports = __webpack_public_path__ + "img/wuhan-3.c92f209f.jpg";